import { useState } from "react";
import { FileSpreadsheet, FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { exportExcel, exportPdf } from "../../lib/exporters";

export function ExportButtons({ fetchRows, columns, name, title }) {
  const [busy, setBusy] = useState("");
  const run = async (kind) => {
    setBusy(kind);
    try {
      const rows = await fetchRows();
      if (kind === "xlsx") await exportExcel(rows, columns, name);
      else await exportPdf(rows, columns, name, title);
    } catch (e) {
      toast.error(`Export failed: ${e.message}`);
    } finally {
      setBusy("");
    }
  };
  const cls = "inline-flex items-center gap-1.5 rounded-full border border-[#D4AF37]/60 bg-white px-3 py-1.5 text-xs font-semibold text-[#7A0016] hover:bg-[#F5E6BA]/50 disabled:opacity-50";
  return (
    <div className="flex gap-2">
      <button type="button" disabled={!!busy} onClick={() => run("xlsx")} data-testid="export-excel-button" className={cls}>
        {busy === "xlsx" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <FileSpreadsheet className="h-3.5 w-3.5" />} Excel
      </button>
      <button type="button" disabled={!!busy} onClick={() => run("pdf")} data-testid="export-pdf-button" className={cls}>
        {busy === "pdf" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <FileText className="h-3.5 w-3.5" />} PDF
      </button>
    </div>
  );
}
